import {debounce, animateBlock, addSubmenuButton} from './modules/helpers.js';
import initFakeSelects  from './modules/initFakeSelects';

// Take some useful functions
import {
	closest_polyfill,
} from './modules/helpers.js';

/**
 * All custom code is wrapped in IIFE function
 * to prevent affect our code to another parts of code
 */
;(function ( $ ) {

	/**
	 * Occurs when all HTML has been fully loaded and passed by the parser,
	 * without waiting for the stylesheets, images and frames to finish loading
	 */
	document.addEventListener("DOMContentLoaded", function(event) {
		// Init Closest polyfill method ( Don't delete it )
		closest_polyfill();
        initFakeSelects(); //innit custom select
        animateBlock(); // innit animate block function
        addSubmenuButton('#menu-header-menu', `<svg viewBox="0 0 9.24805 5.43411" xmlns="http://www.w3.org/2000/svg" width="9.248047" height="5.434113" fill="none" customFrame="#000000"><path id="Vector" d="M0 0L4.21875 4.21875L8.4375 0" fill-rule="nonzero" stroke="rgb(114,113,120)" stroke-width="1.145833" transform="matrix(1,0,0,-1,0.405273,5.02899)" /></svg>`); // innit add for submenu button

		const header          = document.querySelector(".site-header");
		const bannerSlider    = document.querySelector('.js-banner-slider');
		const eventsSlider    = document.querySelector('.js-events-slider');
		const partnersSlider  = document.querySelector('.js-partners-slider');
		const offersSlider    = document.querySelector('.js-offers-slider');
		const coursesSlider   = document.querySelector('.js-courses-slider');
		const directionSlider = document.querySelector('.js-direction-slider');
        const searchInputs    = document.querySelectorAll('.js-input-search');
        const anchor          = document.querySelectorAll('.anchor');
        
        anchor && anchor.forEach(elem => {
            elem.addEventListener('click', event => {
                event.preventDefault();
                const raw = event.target.getAttribute('href')
                if(raw) {
                    window.location.href = `${var_from_php.site_url}/${raw}`;
                }
            })
        })
        
        /**
         * Scroll handler
         */
        /*window.addEventListener( 'scroll', ( event ) => {
            const animateBlock = document.querySelectorAll( '.js-is-animate' );
            
            animateBlock && [...animateBlock].forEach( ( item ) => {
                if ( isInViewport( item, 100 ) ) {
                    item.classList.add('animate');
                } else {
                    item.classList.remove('animate');
                }
            } );
            
        } );*/
        
        searchInputs && searchInputs.forEach(item => {
            item.addEventListener('input', debounce((event) => {
                event.preventDefault();
                const searchVal = event.target.value;
                const parent = event.target.closest('.js-search-input-wrap');
                if(!parent) return;
                const resultElem = parent.querySelector('.js-search-result');
                if(!resultElem) return;
                
                const data = new FormData();
                data.append( 'action', 'ajax_search' );
                data.append( 'search', searchVal );
                
                fetch(var_from_php.ajax_url,
                        {
                            method: "POST",
                            credentials: 'same-origin',
                            body: data
                        })
                        .then((response) => response.json())
                        .then((responseData) => {
                            if(responseData.success) {
                                const html = responseData.data.html;
                                resultElem.innerHTML = html;
                                
                                if(html) {
                                    resultElem.classList.add('open');
                                } else {
                                    resultElem.classList.remove('open');
                                }
                            }
                        })
            }, 500) )
        })
        
        if (directionSlider) {
            new Swiper(".js-direction-slider", {
                spaceBetween: 12,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.js-direction-pagination',
                    clickable: true,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    481: {
                        slidesPerView: 'auto',
                        slidesPerGroup: 1,
                    },
                },
            });
        }
        
        if (coursesSlider) {
            new Swiper(".js-courses-slider", {
                spaceBetween: 12,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.js-courses-pagination',
                    clickable: true,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    481: {
                        slidesPerView: 'auto',
                        slidesPerGroup: 1,
                    },
                },
            });
        }
  
		if (bannerSlider) {
            let bannerSwiper = new Swiper(".js-banner-slider", {
                slidesPerView: "auto",
                spaceBetween: 15,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.js-banner-pagination',
                    clickable: true,
                },
            });
		}
        
        if (eventsSlider) {
            let eventSwiper = new Swiper('.js-events-slider', {
                loop: true,
                spaceBetween: 12,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.js-events-pagination',
                    clickable: true,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    481: {
                        slidesPerView: 'auto',
                        slidesPerGroup: 1,
                    },
                },
            });
        }
        
        if (offersSlider) {
            new Swiper(".js-offers-slider", {
                spaceBetween: 12,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.js-offers-pagination',
                    clickable: true,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    481: {
                        slidesPerView: 'auto',
                        slidesPerGroup: 1,
                    },
                },
            });
        }
        
        if (partnersSlider) {
            new Swiper('.js-partners-slider', {
                spaceBetween: 0,
                loop: true,
                speed: 6000,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
                allowTouchMove: false,
                freeMode: true,
                freeModeMomentum: false,
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    481: {
                        slidesPerView: 'auto',
                        slidesPerGroup: 1,
                    },
                },
            });
        }

		window.addEventListener("scroll", function () {
            const banners = document.querySelectorAll('.js-banner');
            
            banners.forEach(banner => {
                const img = banner.querySelector('.js-banner-img');
                const speed = 0.5;
                const scrollY = window.scrollY * speed;
                img.style.transform = `translateY(${scrollY}px)`;
            });
            
			if (window.scrollY > 80) {
				header.classList.add("scroll");
			} else {
				header.classList.remove("scroll");
			}
		});

		/**
		 * Add global handler for click event
		 * The main idea - to improve site performance
		 * We added only 1 event handler to "click" event
		 * and then use date-role attribute on each( needed ) elements
		 * to define on which element event was executed.
		 */
		document.body.addEventListener( 'click', event => {
			const ROLE = event.target.dataset.role;
			const clickElem = event.target;

			if ( !ROLE ) return;
			switch ( ROLE ) {
                case 'open-format': {
                    event.preventDefault();
                    const parent = clickElem.closest('.js-format-item');
                    const formWrap = parent.querySelector('.js-choice-format-form');
                    clickElem.style.display='none';
                    
                    if(formWrap) {
                        parent.classList.add('active');
                        $(formWrap).slideDown();
                    }
                } break;
                case 'close-format': {
                    event.preventDefault();
                    const parent = clickElem.closest('.js-format-item');
                    const openFormat = parent.querySelector('.js-open-format');
                    const formWrap = parent.querySelector('.js-choice-format-form');
                    
                    if (openFormat) {
                        parent.classList.remove('active');
                        openFormat.style.display='flex';
                    }
                    
                    if(formWrap) {
                        $(formWrap).slideUp();
                    }
                }break;
                case 'set-page' : {
                    event.preventDefault();
                    const parent = clickElem.closest('.js-pagination');
                    const type = parent.dataset.type;
                    const page = clickElem.dataset.page;
                    
                    switch (type) {
                        case 'event': {event_pagination(page)} break;
                        case 'direction': {
                            const termId = parent.dataset.term;
                            direction_pagination(page, termId);
                        } break;
                        case 'partner-offer': {
                            offer_pagination(page);
                        } break;
                        case 'course': {
                            course_pagination(page);
                        } break;
                    }
                } break;
                case 'button-pagination': {
                    event.preventDefault();
                    const parent = clickElem.closest('.js-pagination');
                    const type = parent.dataset.type;
                    const page = clickElem.dataset.page;
                    
                    switch (type) {
                        case 'event': {event_pagination(page)} break;
                        case 'direction': {
                            const termId = parent.dataset.term;
                            direction_pagination(page, termId);
                        } break;
                        case 'partner-offer': {
                            offer_pagination(page);
                        } break;
                        case 'course': {
                            course_pagination(page);
                        } break;
                    }
                } break;
                case 'faq': {
                    event.preventDefault();
                    const content = clickElem.querySelector('.js-answer');
                    
                    if (content) {
                        clickElem.classList.toggle('active')
                        $(content).slideToggle();
                    }
                } break;
                case 'show-password': {
                    event.preventDefault();
                    const parent = clickElem.closest('.js-password-wrap');
                    const passInput = parent.querySelector('.js-pass-input');
                    if (!passInput) return;
                    const typeInput = passInput.type;
                    
                    if(typeInput === 'password') {
                        passInput.type = 'text';
                    } else {
                        passInput.type = 'password';
                    }
                    
                } break
                case 'open-modal': {
                    event.preventDefault();
                    const body = document.querySelector('body');
                    const popupSelector = clickElem.dataset.popup;
                    if(!popupSelector) return;
                    const popup = document.querySelector(`#${popupSelector}`);
                    close_popups();
                    
                    if(popup) {
                        popup.classList.add('show');
                        body && body.classList.add('menu-open');
                    }
                } break;
                case 'logout': {
                    event.preventDefault();
                    const data = new FormData();
                    data.append( 'action', 'log_out_user' );
                    
                    fetch(var_from_php.ajax_url,
                            {
                                method: "POST",
                                credentials: 'same-origin',
                                body: data
                            })
                            .then((response) => response.json())
                            .then((responseData) => {
                                if(responseData.success) {
                                    location.reload();
                                }
                            })
                } break;
                case 'close-popup': {
                    close_popups();
                } break;
                case 'open-search': {
                    event.preventDefault();
                    const parent = clickElem.closest('.js-search-wrap');
                    const result = document.querySelector('.js-search-result');
                    const searchInput = document.querySelector('.js-input-search');
                    if(!parent) return;
                    const inputWrap = parent.querySelector('.js-search-input-wrap');
                    if (!inputWrap) return;
                    
                    if(inputWrap.classList.contains('open')) {
                        inputWrap.classList.remove('open');
                        result.classList.remove('open');
                        searchInput.value = '';
                        result.innerHTML = '';
                    } else {
                        inputWrap.classList.add('open');
                    }
                    
                    
                } break;
                case 'close-menu':
                case 'open-menu': {
                    event.preventDefault();
                    const menu = document.querySelector('.js-site-menu');
                    const body = document.querySelector('body');
                    menu && menu.classList.toggle('hide');
                    body && body.classList.toggle('menu-open');
                    
                } break;
			}
		} );

		document.body.addEventListener( 'input', event => {
			const ROLE = event.target.dataset.role;
			const eventElem = event.target;

			if ( !ROLE ) return;

			switch ( ROLE ) {
				case 'filter-price': {
				} break;
			}

		});

		document.body.addEventListener( 'change', event => {
			const ROLE = event.target.dataset.role;
			const changeElem = event.target;

			if ( !ROLE ) return;

			switch ( ROLE ) {
                case 'sort-event': {
                    event_pagination(1);
                } break;
                case 'sort-courses': {
                    course_pagination(1);
                } break;
                case 'sort-direction': {
                    const parent = changeElem.closest('.js-select-wrap')
                    if(!parent) return;
                    const termId = parent.dataset.term;
                    direction_pagination(1, termId);
                } break;
                case 'sort-offers': {
                    offer_pagination(1);
                } break;
                case 'agree-form': {
                    event.preventDefault();
                    const parentForm = changeElem.closest('form');
                    if(!parentForm) return;
                    const submitButton = parentForm.querySelector('.js-submit-button');
                    if(!submitButton) return;
                    submitButton.disabled = !changeElem.checked;
                } break;
			}
		} );

		document.body.addEventListener( 'submit', async (event) => {
			const ROLE = event.target.dataset.role;
			const submitElem = event.target;

			if ( !ROLE ) return;

			switch ( ROLE ) {
                case 'search-events': {
                    event.preventDefault();
                    event_pagination(1);
                } break;
                case 'search-directions': {
                    event.preventDefault();
                    const termId = submitElem.dataset.term;
                    direction_pagination(1, termId);
                } break;
                case 'search-offers': {
                    event.preventDefault();
                    offer_pagination(1);
                } break;
                case 'search-course': {
                    event.preventDefault();
                    course_pagination(1);
                } break;
                case 'login-user': {
                    event.preventDefault();
                    const data = new FormData(submitElem);
                    data.append( 'action', 'login_user' );
                    
                    fetch(var_from_php.ajax_url,
                            {
                                method: "POST",
                                credentials: 'same-origin',
                                body: data
                            })
                            .then((response) => response.json())
                            .then((responseData) => {
                                if(responseData.success) {
                                    location.href = var_from_php.site_url;
                                } else {
                                    const loginMessage = document.querySelector('.js-login-message');
                                    const message = responseData.data.message;
                                    
                                    if (loginMessage && message) {
                                        loginMessage.innerText = message;
                                    }
                                }
                            })
                } break;
                case 'password_recovery': {
                    event.preventDefault();
                    const data = new FormData(submitElem);
                    const errorWrap = document.querySelector('.js-password_recovery');
                    
                    data.append( 'action', 'password_recovery' );
                    
                    fetch(var_from_php.ajax_url,
                            {
                                method: "POST",
                                credentials: 'same-origin',
                                body: data
                            })
                            .then((response) => response.json())
                            .then((responseData) => {
                                if (errorWrap) {
                                    errorWrap.innerText = responseData.data.message;
                                }
                            })
                } break;
                case 'set-new-password': {
                    event.preventDefault();
                    const password = submitElem.querySelector('input[name="password"]');
                    const confirm = submitElem.querySelector('input[name="confirmation-password"]');
                    const errorWrap = submitElem.querySelector('.js-recovery-password-error');
                    
                    if (!password || !confirm) {
                        return;
                    }
                    
                    if(password.value !== confirm.value) {
                        errorWrap.innerText = 'Паролі не збігаються';
                        return;
                    }
                    
                    const data = new FormData(submitElem);
                    data.append( 'action', 'reset_user_password' );
                    
                    fetch(var_from_php.ajax_url,
                            {
                                method: "POST",
                                credentials: 'same-origin',
                                body: data
                            })
                            .then((response) => response.json())
                            .then((responseData) => {
                                if (errorWrap) {
                                    errorWrap.innerText = responseData.data.message;
                                }
                            })
                } break;
                case 'register-with-role': {
                    event.preventDefault();
                    const data = new FormData(submitElem);
                    data.append( 'action', 'register_user' );
                    
                    fetch(var_from_php.ajax_url,
                            {
                                method: "POST",
                                credentials: 'same-origin',
                                body: data
                            })
                            .then((response) => response.json())
                            .then((responseData) => {
                                if(responseData.success) {
                                    location.href = var_from_php.site_url;
                                } else {
                                    const loginMessage = document.querySelector('.js-register-message');
                                    const message = responseData.data.message;
                                    
                                    if (loginMessage && message) {
                                        loginMessage.innerText = message;
                                    }
                                }
                            })
                } break;
                case 'form-block': {
                    event.preventDefault();
                    send_mail(submitElem)
                } break
			}
		});
	});


	// Use it when you need to know that everything is loaded (html, styles, images)
	window.addEventListener('load', (event) => {});
    
    document.addEventListener('DOMContentLoaded', () => {
    
    });

})( jQuery );

function send_mail (submitElem) {
    const data = new FormData(submitElem);
    data.append( 'action', 'send_message' );
    
    fetch(var_from_php.ajax_url,
            {
                method: "POST",
                credentials: 'same-origin',
                body: data
            })
            .then((response) => response.json())
            .then((responseData) => {
                const answer = document.querySelector('.js-form-answer');
                
                if(responseData.success) {
                    if(answer) {
                        answer.innerText = responseData.data.message;
                    }
                    
                    submitElem.reset();
                    
                    const popup = document.querySelector(`#mail-success`);
                    if(popup) {
                        popup.classList.add('show');
                        body && body.classList.add('menu-open');
                    }
                } else {
                    if(answer) {
                        answer.innerText = responseData.data.message;
                    }
                }
                
                setTimeout(() => {
                    answer.innerText = '';
                }, 3000)
            })
}

function close_popups () {
    const popups = document.querySelectorAll('.js-popup');
    const body = document.querySelector('body');
    if(popups) {
        popups.forEach( item => {
            item.classList.remove('show');
        })
        
        body && body.classList.remove('menu-open');
    }
}

function course_pagination (page) {
    const sort = document.querySelector('.js-sort-select').value;
    const filterForm = document.querySelector('form[data-role="search-course"]');
    const nextButton = document.querySelector('.js-next-button');
    const prevButton = document.querySelector('.js-pref-button');
    
    const data = new FormData(filterForm);
    data.append( 'action', 'get_course' );
    data.append( 'sort', sort );
    data.append( 'page', page );
    
    fetch(var_from_php.ajax_url,
            {
                method: "POST",
                credentials: 'same-origin',
                body: data
            })
            .then((response) => response.json())
            .then((responseData) => {
                if(responseData.success) {
                    const greed = document.querySelector('.js-сourses-greed');
                    const pagination = document.querySelector('.js-courses-pagination');
                    
                    if(greed ) {
                        greed.innerHTML = responseData.data.content;
                    }
                    
                    if(pagination) {
                        pagination.innerHTML = responseData.data.pagination;
                    }
                    
                    if(nextButton) {
                        nextButton.dataset.page = responseData.data.next;
                    }
                    
                    if(prevButton && responseData.data.prev !== '0') {
                        prevButton.dataset.page = responseData.data.prev;
                    }
                    
                    animateBlock();
                    
                }
            })
}

function offer_pagination (page) {
    const sort       = document.querySelector('.js-sort-select').value;
    const filterForm = document.querySelector('form[data-role="search-offers"]');
    const nextButton = document.querySelector('.js-next-button');
    const prevButton = document.querySelector('.js-pref-button');
    
    const data = new FormData(filterForm);
    data.append( 'action', 'get_offers' );
    data.append( 'sort', sort );
    data.append( 'page', page );
    
    fetch(var_from_php.ajax_url,
            {
                method: "POST",
                credentials: 'same-origin',
                body: data
            })
            .then((response) => response.json())
            .then((responseData) => {
                if(responseData.success) {
                    const greed = document.querySelector('.js-offer-greed');
                    const pagination = document.querySelector('.js-offer-pagination');
                    
                    if(greed ) {
                        greed.innerHTML = responseData.data.content;
                    }
                    
                    if(pagination) {
                        pagination.innerHTML = responseData.data.pagination;
                    }
                    
                    if(nextButton) {
                        nextButton.dataset.page = responseData.data.next;
                    }
                    
                    if(prevButton && responseData.data.prev !== '0') {
                        prevButton.dataset.page = responseData.data.prev;
                    }
                    
                    animateBlock();
                }
            })
}

function direction_pagination (page, termId) {
    const sort = document.querySelector('.js-sort-select').value;
    const filterForm = document.querySelector('form[data-role="search-directions"]');
    const nextButton = document.querySelector('.js-next-button');
    const prevButton = document.querySelector('.js-pref-button');
    
    const data = new FormData(filterForm);
    data.append( 'action', 'get_direction' );
    data.append( 'sort', sort );
    data.append( 'page', page );
    data.append( 'term_id', termId );
    
    fetch(var_from_php.ajax_url,
            {
                method: "POST",
                credentials: 'same-origin',
                body: data
            })
            .then((response) => response.json())
            .then((responseData) => {
                if(responseData.success) {
                    const greed = document.querySelector('.js-direction-greed');
                    const pagination = document.querySelector('.js-direction-pagination');
                    
                    if(greed ) {
                        greed.innerHTML = responseData.data.content;
                    }
                    
                    if(pagination) {
                        pagination.innerHTML = responseData.data.pagination;
                    }
                    
                    if(nextButton) {
                        nextButton.dataset.page = responseData.data.next;
                    }
                    
                    if(prevButton && responseData.data.prev !== '0') {
                        prevButton.dataset.page = responseData.data.prev;
                    }
                    
                    animateBlock();
                }
            })
}

function event_pagination (page) {
    const sort = document.querySelector('.js-sort-select').value;
    const filterForm = document.querySelector('form[data-role="search-events"]');
    const nextButton = document.querySelector('.js-next-button');
    const prevButton = document.querySelector('.js-pref-button');
    
    const data = new FormData(filterForm);
    data.append( 'action', 'get_events' );
    data.append( 'sort', sort );
    data.append( 'page', page );
    
    fetch(var_from_php.ajax_url,
            {
                method: "POST",
                credentials: 'same-origin',
                body: data
            })
            .then((response) => response.json())
            .then((responseData) => {
                if(responseData.success) {
                    const greed = document.querySelector('.js-event-greed');
                    const pagination = document.querySelector('.js-events-pagination');
                    
                    if(greed ) {
                        greed.innerHTML = responseData.data.content;
                    }
                    
                    if(pagination) {
                        pagination.innerHTML = responseData.data.pagination;
                    }
                    
                    if(nextButton) {
                        nextButton.dataset.page = responseData.data.next;
                    }
                    
                    if(prevButton && responseData.data.prev !== '0') {
                        prevButton.dataset.page = responseData.data.prev;
                    }
                    
                    animateBlock();
                   
                }
            })
}

